import { render, staticRenderFns } from "./SimpleRectChart.vue?vue&type=template&id=3855d85a&"
import script from "./SimpleRectChart.vue?vue&type=script&lang=js&"
export * from "./SimpleRectChart.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRectChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports